import {ReactNode} from 'react';
import {SchemeLink} from '../../../applink/SchemeLink';
import {requestContext} from '../../../common/requestContext';
import {KakaoentPolicyType} from '../type';
import {getKakaoentPolicyUrl} from '../util/getKakaoentPolicyUrl';

/**
 * 카카오엔터 공용으로 사용하는 약관 페이지로 이동하는 링크입니다
 */
export function KakaoentPolicyLink({
  policyType,
  schemeType = 'inApp',
  children,
}: {
  policyType: KakaoentPolicyType;
  schemeType?: 'inApp' | 'browser';
  children: ReactNode;
}) {
  return requestContext.requestInfo.display.isWebView ? (
    <SchemeLink
      scheme={
        schemeType === 'inApp'
          ? getKakaoentPolicyUrl({type: policyType}).webInAppScheme()
          : getKakaoentPolicyUrl({type: policyType}).externalBrowserScheme()
      }
    >
      {children}
    </SchemeLink>
  ) : (
    <a
      target="_blank"
      href={getKakaoentPolicyUrl({type: policyType}).urlExcludeVod().href}
      rel="noreferrer"
      className="cursor-pointer"
    >
      {children}
    </a>
  );
}
